import React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import { useGetTile } from '../../api/dashboard_tile';

const Tile = ({ tile_key, locale = 'en-US' }) => {
    const { data: tileConfig, isLoading: isLoadingTile } = useGetTile(tile_key);
    console.log("Tile config", tileConfig);

    function formatTileValue(tileConfig) {
        if (!tileConfig) return { value: "", label: "" };
        const { format, label, singleLabel, result } = tileConfig;
        const labelToUse = result === 1 && singleLabel ? singleLabel : label;
        const formatter = new Intl.NumberFormat(locale, JSON.parse(format));
        return {
            value: formatter.format(result),
            label: labelToUse
        };
    }

    if (isLoadingTile || !tileConfig) {
        return (
            <Grid item xl={3} lg={4} md={6} xs={12}>
                <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2 }} />
            </Grid>
        );
    }

    const { value, label } = formatTileValue(tileConfig);

    return (
        <Grid item xl={3} lg={4} md={6} xs={12}>
            <Card
                elevation={0}
                sx={{
                    height: '100%',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 2,
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                        transform: 'translateY(-4px)',
                        borderColor: 'primary.main'
                    }
                }}
            >
                <CardContent sx={{
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    height: '100%',
                    '&:last-child': { pb: 3 }
                }}>
                    <Typography
                        component="div"
                        sx={{
                            fontWeight: 700,
                            fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
                            letterSpacing: '0.02em',
                            color: '#000000',
                            textTransform: 'uppercase',
                            mb: 2,
                            lineHeight: 1.4
                        }}
                    >
                        {label}
                    </Typography>
                    <Typography
                        component="div"
                        sx={{
                            fontWeight: 700,
                            color: 'primary.main',
                            fontSize: { xs: '2.5rem', sm: '3rem', md: '3.5rem' },
                            lineHeight: 1.2,
                        }}
                    >
                        {value}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    );
}

export default Tile;